import { render, staticRenderFns } from "./chuxiang.vue?vue&type=template&id=237e8cc4&scoped=true&"
import script from "./chuxiang.vue?vue&type=script&lang=js&"
export * from "./chuxiang.vue?vue&type=script&lang=js&"
import style0 from "./chuxiang.vue?vue&type=style&index=0&id=237e8cc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237e8cc4",
  null
  
)

export default component.exports